import { render, staticRenderFns } from "./ClienteHistorialPedidos.vue?vue&type=template&id=8bf35a28"
import script from "./ClienteHistorialPedidos.vue?vue&type=script&lang=js"
export * from "./ClienteHistorialPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports